import React, { useEffect, useState } from "react";
import serviceApi from "../../../services/serviceApi";
import environment from "../../../environments/environment";
import ExamResult from "./ExamResult";

type ScheduleRow = {
    subject: string;
    maxMrks: string;
    minMrks: string;
    date: string;
    time: string;
    endTime?: string;
    status: string;
    id: string;
};

interface ExamScheduleProps {
    entityId: string;
    onBack?: () => void;
    calendarMode?: boolean;
}

const ExamSchedule: React.FC<ExamScheduleProps> = ({
    entityId,
    onBack,
    calendarMode = false
}) => {
    const [schedule, setSchedule] = useState<ScheduleRow[]>([]);
    const [loading, setLoading] = useState(false);
    const [showResult, setShowResult] = useState(false);

    useEffect(() => {
        loadSchedule();
    }, [entityId]);

    const loadSchedule = async () => {
        if (!entityId) return;

        try {
            setLoading(true);
            const response = await serviceApi.get<any>(
                `${environment.examschedule}?entityId=${encodeURIComponent(entityId)}`
            );
            if (response?.status === "SUCCESS") {
                setSchedule(response.dataList || []);
            } else {
                setSchedule([]);
            }
        } catch (error) {
            console.error("Schedule API Error:", error);
            setSchedule([]);
        } finally {
            setLoading(false);
        }
    };
    if (!calendarMode && showResult) {
        return (
            <ExamResult
                entityId={entityId}
                onBack={() => setShowResult(false)}
            />
        );
    }
    return (
        <>
            {onBack && (
                <div
                    style={{
                        position: "relative",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "35px 12px 15px 12px",
                        minHeight: "40px"
                    }}
                >
                    <button
                        onClick={onBack}
                        style={{
                            position: "absolute",
                            left: "12px",
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: "var(--colorPrimaryDark)",
                            padding: 0,
                            margin: 0
                        }}
                    >
                        ← Back
                    </button>

                    <h2
                        className="title-text notification-heading"
                        style={{
                            margin: 0,
                            textAlign: "center"
                        }}
                    >
                        {entityId}
                    </h2>
                </div>
            )}
            {loading && (
                <div className="loading-overlay">
                    <div className="loading-overlay__content">
                        <div className="spinner spinner--lg"></div>
                        <span className="loading-text">
                            Loading Schedule...
                        </span>
                    </div>
                </div>
            )}
            {!loading && (
                <div
                    className="event-container"
                    style={{
                        marginTop: "12px",
                        marginBottom: "16px"
                    }}
                >
                    <div
                        className="table-container"
                        style={{ padding: 0 }}
                    >
                        <div
                            className="table-slider">
                            <div className="table-wrapper">
                                <div className="table-responsive">
                                    <table
                                        className="table exam-table"
                                        style={{ margin: 0 }}
                                    >
                                        <thead>
                                            <tr>
                                                <th>Subject</th>
                                                <th>Date</th>
                                                <th>Time</th>
                                                <th>Max Marks</th>
                                                <th>Pass Marks</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {schedule.length > 0 ? (
                                                schedule.map((row, idx) => (
                                                    <tr key={idx}>
                                                        <td
                                                            style={{
                                                                fontWeight: 600
                                                            }}
                                                        >
                                                            {row.subject}
                                                        </td>

                                                        <td>{row.date}</td>

                                                        <td>
                                                            {row.time}
                                                            {row.endTime
                                                                ? ` - ${row.endTime}`
                                                                : ""}
                                                        </td>
                                                        <td>{row.maxMrks}</td>

                                                        <td>{row.minMrks}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td
                                                        colSpan={5}
                                                        style={{
                                                            textAlign: "center",
                                                            padding: "10px"
                                                        }}
                                                    >
                                                        Schedules not yet published
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                {schedule.length > 0 && !calendarMode && (
                                    <div className="table-nav-button right-arrow">
                                        <button
                                            className="icon-btn"
                                            onClick={() => setShowResult(true)}
                                        >
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ExamSchedule;